import axios from "axios";
import { ILoginRequest, IUser, IUserTemp } from "models/Login/login.model";
import { store } from "redux/store";
import { RSAEncrypt } from "utils/CryptOperations/Rsa-encrypt";

export const Login = async (loginParams: ILoginRequest): Promise<IUser> => {
  try {
    const reduxStore = store.getState();
    const passEnc = loginParams.reLogin
      ? loginParams.password
      : RSAEncrypt(loginParams.password!);
    loginParams.password = passEnc;

    const kullaniciAdiEnc = loginParams.adSoyad
      ? RSAEncrypt(loginParams.adSoyad!)
      : "";
    loginParams.adSoyad = kullaniciAdiEnc;
    loginParams.clientUid = reduxStore.login.clientUID;

    const reqData = serviceLoginModelCreator(loginParams);
    const { data } = await axios.post<IUser>("/Token", reqData);

    if (data.IsSimBlock) {
      const errSimMsg =
        "Sim kartınız blokeli olduğu için E-Belgeli POS Web Portal'a giriş yapamazsınız. Sim kart blokenizi açmak için işyeri sahibinizle iletişime geçilmesi gerekmektedir.";
      throw errSimMsg;
    }
    if (data.isUserNameRequired) return data;
    if (data.DialogBoxes.length > 0) throw data.DialogBoxes[0].Message;

    data.corporateOrIndividual = loginParams.corporateIndividual;
    data.mbb_phoneNumber = loginParams.phoneNumber;

    const tmp: IUserTemp = {
      mbb:
        loginParams.corporateIndividual === "2"
          ? loginParams.phoneNumber
          : loginParams.merchantNumber,
      igsEnc: loginParams.password,
      TokenSessionId: "",
      UserId: loginParams.corporateIndividual === "2" ? "" : loginParams.userId,
      corporateIndividual: loginParams.corporateIndividual,
    };
    data.userTemp = { ...tmp };
    data.mbb_userCode = loginParams.userId;

    return data;
  } catch (error) {
    console.log(`LOGIN_SERVICE_ERROR => `, error);
    throw error;
  }
};

const serviceLoginModelCreator = (loginParams: ILoginRequest) => {
  let req = {};
  if (loginParams.corporateIndividual === "2") {
    //b
    req = {
      mbb: loginParams.phoneNumber,
      igsEnc: loginParams.password,
      TokenSessionId: "",
      androidUID: loginParams.clientUid,
      carrier: "Turk Telekom",
      changeKey: null,
      ChannelKey: "POS-RTL-WUN-MBB",
      clientDeviceID: null,
      ClientUid: loginParams.clientUid,
      connectionType: "GSM",
      DeviceBrand: "samsung",
      DeviceModel: "SM-N970F",
      deviceOs:
        "ANDROID 12|V1.1.9|SAMSUNG SM-N970F|TR|304634344143323645363741|Galaxy Note10",
      deviceOsType: "Android",
      DeviceOsVersion: "12",
      deviceType: "SMARTPHONE-MPOS",
      deviceVersion: "1.1.9",
      hardOtpFlag: false,
      imei: loginParams.clientUid,
      isCracked: "0",
      softOtpFlag: false,
      kullAdiEnc: loginParams.adSoyad,
      userAgent:
        "Mozilla/5.0 (Linux; Android 12; SM-N970F Build/SP1A.210812.016; wv) AppleWebKit/537.36 (KHTML, like Gecko) Version/4.0 Chrome/106.0.5249.126 Mobile Safari/537.36",
      CallbackFunctionId: null,
      isBusy: false,
      isNativeFlag: "true",
      Language: "tr-TR",
      NextTransactionUrl: "ModAuthWebFirst",
    };
  } else {
    // k
    req = {
      mbb: loginParams.merchantNumber,
      UserId: loginParams.userId,
      igsEnc: loginParams.password,
      TokenSessionId: "",
      channelType: "MBB",
      ChannelKey: "POS-CRP-WUN-MBB",
      androidUID: loginParams.clientUid,
      carrier: "Turk Telekom",
      changeKey: null,
      clientDeviceID: null,
      ClientUid: loginParams.clientUid,
      connectionType: "GSM",
      DeviceBrand: "samsung",
      DeviceModel: "SM-N970F",
      deviceOs:
        "ANDROID 12|V1.2.0|SAMSUNG SM-N970F|TR|363332443234424333463044|Galaxy Note10",
      deviceOsType: "Android",
      DeviceOsVersion: "12",
      deviceType: "SMARTPHONE-MPOS",
      deviceVersion: "1.2.0",
      hardOtpFlag: false,
      imei: loginParams.clientUid,
      isCracked: "0",
      softOtpFlag: false,
      kullAdiEnc: loginParams.adSoyad,
      userAgent:
        "Mozilla/5.0 (Linux; Android 12; SM-N970F Build/SP1A.210812.016; wv) AppleWebKit/537.36 (KHTML, like Gecko) Version/4.0 Chrome/109.0.5414.118 Mobile Safari/537.36",
      CallbackFunctionId: null,
      isBusy: false,
      isNativeFlag: "true",
      Language: "tr-TR",
      NextTransactionUrl: "ModAuthCorpWebFirst",
    };
  }

  return req;
};
